import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { categories } from '../../data/collections';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? 'success' : 'error');
  };
  return <footer className="mt-auto bg-ink text-canvas" data-id="element-171" data-mp="3s25au80ovbfw">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-12 lg:px-8" data-id="element-172" data-mp="3s1ce7zvg22bh">
        <div className="lg:col-span-5" data-id="element-173" data-mp="3n43qljrj162u">
          <p className="text-2xl font-semibold tracking-[0.24em]" data-id="element-174" data-mp="3j1z3z4zhx9pp">AMIRA</p>
          <p className="mt-2 text-sm text-canvas/60" data-id="element-175" data-mp="3izw29nozds55">Pure. Clear. Proven.</p>
          <h2 className="mt-10 text-base font-semibold" data-id="element-176" data-mp="3e2cnmmodfdco">10% korting op je eerste bestelling</h2>
          {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-sm" role="status" data-id="element-177" data-mp="3965i2uzw03v9">
              <CheckIcon className="h-4 w-4 text-[#E7B79F]" data-id="element-178" data-mp="2kbtkcxoaqgms" /> Check je inbox voor je code.
            </p> : <form onSubmit={submit} noValidate className="mt-4" data-id="element-179" data-mp="2bceuo0fyea3c">
              <label htmlFor="nl-email" className="sr-only" data-id="element-180" data-mp="2bdzqruhx213b">E-mailadres</label>
              <div className="flex gap-2" data-id="element-181" data-mp="2gckptqlfmeq6">
                <input id="nl-email" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              if (status === 'error') setStatus('idle');
            }} placeholder="jouw@email.nl" aria-invalid={status === 'error'} className="h-11 min-w-0 flex-1 rounded-full border border-canvas/20 bg-transparent px-4 text-sm text-canvas placeholder:text-canvas/40 focus:border-canvas focus:outline-none" data-id="element-182" data-mp="2g958si876vm4" />
                <button type="submit" className="h-11 whitespace-nowrap rounded-full bg-canvas px-5 text-sm font-medium text-ink hover:bg-surface" data-id="element-183" data-mp="1nkrbk4oxo3bm">
                  Aanmelden
                </button>
              </div>
              {status === 'error' && <p className="mt-2 text-xs text-[#E7B79F]" data-id="element-184" data-mp="urw8kz49bsca">Vul een geldig e-mailadres in.</p>}
            </form>}
        </div>

        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7 lg:col-start-6" data-id="element-185" data-mp="pstajymp2mdt">
          <FooterCol title="Shop" links={mainNav.map(n => ({
          to: n.to,
          label: n.label
        }))} data-id="element-186" data-mp="kvt4votrbln8" />
          <FooterCol title="Categorieën" links={categories.map(c => ({
          to: `/collectie/${c.id}`,
          label: c.title
        }))} data-id="element-187" data-mp="fudle1789n6y" />
          <FooterCol title="Over AMIRA" links={[{
          to: '/over-amira',
          label: 'Ons verhaal'
        }, {
          to: '/over-amira#ritueel',
          label: 'Het hammam-ritueel'
        }, {
          to: '/product/hammam-ritueel-set',
          label: 'Hammam Ritueel Set'
        }]} data-id="element-188" data-mp="bttkcmjj9zfj" />
        </div>
      </div>
      <div className="border-t border-canvas/10" data-id="element-189" data-mp="28sai7h3lna8q">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-6 text-xs text-canvas/50 sm:flex-row lg:px-8" data-id="element-190" data-mp="28rqvzo6x1zow">
          <span data-id="element-191" data-mp="2ihtwsaka4hxs">© 2026 AMIRA · Geïnspireerd door Aït Baha, Marokko</span>
          <span data-id="element-192" data-mp="2ijwz9u2mc3je">iDEAL · Creditcard · Klarna · PayPal</span>
        </div>
      </div>
    </footer>;
}
function FooterCol({
  title,
  links
}: {
  title: string;
  links: {
    to: string;
    label: string;
  }[];
}) {
  return <div data-id="element-193" data-mp="1pvhlfav83r9n">
      <h3 className="text-sm font-semibold" data-id="element-194" data-mp="1us82o1irkswn">{title}</h3>
      <ul className="mt-4 space-y-2.5" data-id="element-195" data-mp="1usrjtg0lbd9m">
        {links.map(l => <li key={l.label} data-id="element-196" data-mp="1zr2svoj29jqs">
            <Link to={l.to} className="text-sm text-canvas/60 transition-colors duration-150 hover:text-canvas" data-id="element-197" data-mp="1zprfqy3q6zn0">
              {l.label}
            </Link>
          </li>)}
      </ul>
    </div>;
}